import Cookies from 'js-cookie'

const TokenKey = 'token';
const UserName = 'userName';
const Menus = 'menus';

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserName() {
  return Cookies.get(UserName)
}

export function setUserName(userName) {
  return Cookies.set(UserName, userName)
}

export function removeUserName() {
  return Cookies.remove(UserName)
}

export function getMenus() {
  // return Cookies.get(Menus)
  return window.localStorage.getItem(Menus);
}

export function setMenus(menus) {
  // return Cookies.set(Menus, menus)
  return window.localStorage.setItem(Menus, menus);
}

export function removeMenus() {
  // return Cookies.remove(Menus)
  return window.localStorage.removeItem(Menus);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js